/* Original, side-effect-free custom field rules. Civil dates never use UTC conversion. */
(() => {
  'use strict';
  const localISO = date => [date.getFullYear(),String(date.getMonth()+1).padStart(2,'0'),String(date.getDate()).padStart(2,'0')].join('-');
  function civil(value) {
    if (!/^\d{4}-\d{2}-\d{2}$/.test(value || '')) return null;
    const [year,month,day] = value.split('-').map(Number);
    const date = new Date(0); date.setUTCFullYear(year,month-1,day);date.setUTCHours(0,0,0,0);
    return date.getUTCFullYear()===year&&date.getUTCMonth()===month-1&&date.getUTCDate()===day?date:null;
  }
  function dateError(value,rules,today=localISO(new Date())) {
    if (!value) return '';
    const date=civil(value);if(!date)return rules.error||rules.dayError;
    if(rules.allowPast!=='true'&&value<today)return rules.error||rules.pastError;
    const day=date.getUTCDay(),allowed=String(rules.days||'').split(',').filter(x=>/^[0-6]$/.test(x));
    if(!allowed.includes(String(day)))return rules['error-'+day]||rules['error'+day]||rules.error||rules.dayError;
    return '';
  }
  function remaining(end,now=Date.now()) {
    // A timezone is mandatory to avoid silently changing an event's deadline by market.
    if(!/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}(?::\d{2})?(?:Z|[+-]\d{2}:\d{2})$/.test(end||''))return null;
    const deadline=Date.parse(end);if(!Number.isFinite(deadline)||!civil(end.slice(0,10)))return null;
    const seconds=Math.max(0,Math.ceil((deadline-now)/1000));
    return {seconds,days:Math.floor(seconds/86400),hours:Math.floor(seconds%86400/3600),minutes:Math.floor(seconds%3600/60),remainder:seconds%60};
  }
  const api={localISO,civil,dateError,remaining};
  if(typeof module==='object'&&module.exports)module.exports=api;else window.PawContentCore=api;
})();
